import React from "react";

const HeaderTitle = ({ children, className, tag: Tag = "h1", ...rest }) => (
  <Tag className={`header-title ${className || ""}`} {...rest}>
    {children}
  </Tag>
);

export default HeaderTitle;

